var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4767 13.0006C19.478 9.64922 16.6323 0.0012207 16.6323 0.0012207C16.6323 0.0012207 19.0165 13.0006 24.0156 13.0006C19.0165 13.0006 16.6323 26 16.6323 26C16.6323 26 19.3241 17.0629 26.4767 13.0006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.943075 13.0012L25.2463 13.0012L22.9536 12.1887L0.943075 13.0012Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.943075 13.0008L25.2463 13.0008L22.9536 13.8132L0.943075 13.0008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrayBtn);
export default __webpack_public_path__ + "static/media/array-btn.61e9d60c2c395a705e6a420f704531fa.svg";
export { ForwardRef as ReactComponent };